// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__AasOy","loaderOuter":"PageOverlayLoader_loaderOuter__3-NE5"};